<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                 <v-icon>mdi-filter-variant</v-icon> Date Range
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="reportForm.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom"
                          data-vv-name="reportForm.tranDateFrom" :error-messages="errors.collect('reportForm.tranDateFrom')" v-validate="tranDateFromValidation"></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="reportForm.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo"
                          data-vv-name="reportForm.tranDateTo" :error-messages="errors.collect('reportForm.tranDateTo')" v-validate="tranDateToValidation"></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            :label="labels.pbPrtParam"
            v-model="reportForm.pbPrtParam"
            :error-messages="errors.collect('pbPrtParam')"
            data-vv-name="pbPrtParam"
            :data-vv-as="labels.pbPrtParam"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <span class="info-dialog-msg-header">Oops something went wrong...</span>
            <v-spacer class="mt-2"></v-spacer>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import { extractMenu } from '@/utils/extract'
import clone from 'clone'

export default {
  data() {
    return {
      labels: {
        dateRange: '',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        export: 'Export To',
        selectionCriteria: 'Selection Criteria',
        pbPrtParam: 'Print Runtime Parameters',
        format: 'PDF'
      },
      reportForm: {
        tranDateFrom: null,
        tranDateTo: null,
        format: undefined,
        pbPrtParam: true
      },
      showErrorDialog: false,
      submitting: false,
      supportedFormat: ['PDF', 'XLSX'],
      panel1: [0],
      panel2: [0],
      panel3: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.custom1Reports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    tranDateFromValidation() {
      return 'required'
    },
    tranDateToValidation() {
      const result = 'required|valTranDateTo:' + this.reportForm.tranDateFrom
      return result
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function(messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.custom1Reports.init !== 1) {
          await this.$store.dispatch('custom1ReportsInit')
        }
        const apiURI = this.rptMenu.polReviewRelUsr
        const result = await this.$http.get(apiURI)
        if (result.data) {
          this.menu = extractMenu(result.data._links)
          // this.getPolTypeList()
        }
      } catch (err) {
        const { data } = err.response
        if (data) {
          this.message(data)
          this.fieldMessage(data)
        }
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.submitting = true
          let clonedForm = clone(this.reportForm)
          await this.$http.post(apiURI, clonedForm)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    displayErrorDialog() {
      return this.messages
    }
  },
  created() {
    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranDateFrom = args[0]
        if (tranDateFrom) {
          return !(isAfter(removeTime(value), removeTime(tranDateFrom)))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'The Transaction Date To cannot be earlier than From Transaction Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !(isAfter(removeTime(tranToDate), removeTime(value)))
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
  }
}
</script>

<style>

</style>
